module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyWash@2x_93f753.png";